<span class="font-semibold text-default">{{ 'Checklist guide' | translate }}</span>
<button sb-button [color]="'transparent'" [size]="'sm'" (click)="getStarted.emit()">
  {{ 'Getting started' | translate }}
</button>
